export default "__VITE_ASSET__941db700__"